import { Tooltip } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';

export type VerificationFilterValue = boolean | null;

const OPTIONS: Array<{
  value: boolean;
  label: string;
  hex: string;
  bg: string;
  Icon: typeof CheckCircleOutlined;
}> = [
  { value: true,  label: 'Tasdiqlangan',   hex: '#10B981', bg: '#ECFDF5', Icon: CheckCircleOutlined },
  { value: false, label: 'Tasdiqlanmagan', hex: '#F59E0B', bg: '#FFFBEB', Icon: ClockCircleOutlined },
];

interface VerificationFilterProps {
  /** `true` = Tasdiqlangan, `false` = Tasdiqlanmagan, `null` = no filter. */
  value: VerificationFilterValue;
  onChange: (next: VerificationFilterValue) => void;
}

/**
 * Two-pill filter for `isDriverVerified`. Sits next to the page title
 * alongside the call-colour filter pills.
 */
export const VerificationFilter: React.FC<VerificationFilterProps> = ({
  value,
  onChange,
}) => {
  return (
    <span style={{ display: 'inline-flex', gap: 6, marginLeft: 12, verticalAlign: 'middle' }}>
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        const { Icon } = opt;
        return (
          <Tooltip
            key={String(opt.value)}
            title={active ? 'Filterni olib tashlash' : `Filter: ${opt.label}`}
          >
            <button
              type="button"
              onClick={() => onChange(active ? null : opt.value)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '4px 10px',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.15s',
                color: active ? '#fff' : opt.hex,
                background: active ? opt.hex : opt.bg,
                border: `1px solid ${active ? opt.hex : opt.hex + '33'}`,
                lineHeight: 1.2,
                whiteSpace: 'nowrap',
              }}
            >
              <Icon style={{ fontSize: 13 }} />
              {opt.label}
            </button>
          </Tooltip>
        );
      })}
    </span>
  );
};
